import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="revelar-progresivo"
//
// Revela de golpe elementos que YA están en el HTML servido: no pide nada al servidor.
// Los que sobran del tramo visible llegan con el atributo `hidden` puesto desde la vista,
// así que sin JavaScript la página se sirve completa y el botón ni se ve.
export default class extends Controller {
  static targets = ['item', 'boton']
  static values = { visibles: Number, incremento: Number }

  connect () {
    this.aplicarVisibilidad()
  }

  revelar (event) {
    event.preventDefault()
    this.visiblesValue += this.incrementoValue
    this.aplicarVisibilidad()
  }

  // El botón desaparece en la MISMA pulsación que agota la lista: nunca queda una
  // pulsación que no añada nada.
  aplicarVisibilidad () {
    this.itemTargets.forEach((item, indice) => { item.hidden = indice >= this.visiblesValue })

    if (!this.hasBotonTarget) return

    const quedanOcultos = this.visiblesValue < this.itemTargets.length

    this.botonTarget.hidden = !quedanOcultos
    this.botonTarget.querySelector('button')?.setAttribute('aria-expanded', String(!quedanOcultos))
  }
}
